<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="doCancel">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
          <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
          <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="tranMode === 'New'">New Branch Direct or RI</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Review'">Edit Branch Direct or RI</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Query'">View Branch Direct or RI</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex lg6 md6 xs12>
                <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
                <div class="queryValue">{{ DriForm.branch }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="tranMode === 'New'"
                ><v-autocomplete
                  :label="labels.dri"
                  :items="driList"
                  v-model="DriForm.dri"
                  item-text="label"
                  item-value="value"
                  data-vv-name="dri"
                  :data-vv-as="labels.dri"
                  :error-messages="errors.collect('dri')"
                  v-validate="'required|param'"
                ></v-autocomplete
              ></v-flex>
              <v-flex lg6 md6 xs12 v-if="tranMode === 'Review' || tranMode === 'Query'">
                <v-subheader class="queryLabel">{{ labels.dri }}</v-subheader>
                <div class="queryValue">{{ DriText }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-show="showThis"
                ><v-checkbox :label="labels.genPolNo" v-model="DriForm.genPolNo" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12 v-show="showThis"
                ><v-checkbox :label="labels.genRenNo" v-model="DriForm.genRenNo" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12><v-checkbox :label="labels.genClmNo" v-model="DriForm.genClmNo" :disabled="checkTranMode()"></v-checkbox></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.perPolStp" v-model="DriForm.perPolStp" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.perPolFee" v-model="DriForm.perPolFee" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.perPolTax" v-model="DriForm.perPolTax" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.perRiskStp" v-model="DriForm.perRiskStp" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12 v-show="showThis"
                ><v-checkbox :label="labels.riskStpCls" v-model="DriForm.riskStpCls" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.riskStpInstall" v-model="DriForm.riskStpInstall" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.perRiskFee" v-model="DriForm.perRiskFee" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12 v-show="showThis"
                ><v-checkbox :label="labels.riskFeeCls" v-model="DriForm.riskFeeCls" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.riskFeeInstall" v-model="DriForm.riskFeeInstall" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.perRiskTax" v-model="DriForm.perRiskTax" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12 v-show="showThis"
                ><v-checkbox :label="labels.riskTaxCls" v-model="DriForm.riskTaxCls" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
              <v-flex lg6 md6 xs12
                ><v-checkbox :label="labels.riskTaxInstall" v-model="DriForm.riskTaxInstall" :disabled="checkTranMode()"></v-checkbox
              ></v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex lg6 md6 xs12>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdName }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ DriForm.createdDate }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="tranMode === 'Review' || tranMode === 'Query'">
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedName }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="tranMode === 'Review' || tranMode === 'Query'">
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ DriForm.modifiedDate }}</div>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mr-2" color="error" dark @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
                <v-btn v-if="tranMode === 'New' || tranMode === 'Review'" color="primary" type="submit" @click.prevent="doSaveBranchDRI">
                  Save
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-card v-if="tranMode === 'Review' || tranMode === 'Query'">
        <message :messages="messages" v-if="listMessage"></message>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-view-list</v-icon>
          <v-toolbar-title>Branch Fee</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          <v-flex lg6 md6 xs12><cal-picker label="Filter By Date" single-line hide-details v-model="search"></cal-picker></v-flex>
          <v-layout row>
            <v-spacer></v-spacer>
            <v-btn v-if="tranMode === 'Review'" class="mr-2" color="primary" dark @click="doNewBranchFee"> New Branch Fee<v-icon right>mdi-plus</v-icon> </v-btn>
            <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" class="white--text" v-on="on">
                  <span>Columns</span>
                  <v-icon right dark>mdi-table-column-plus-after</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-text>
                  <template v-if="columns.length > 0">
                    <v-checkbox
                      v-for="column in columns"
                      :key="column.value"
                      :label="column.text"
                      :value="column.value"
                      v-model="selectedColumns"
                    ></v-checkbox>
                  </template>
                  <template v-else> No column found </template>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-layout>
        </v-card-title>
        <v-flex xs12 class="mt-2">
          <v-data-table
            item-key
            :headers="listHeaders"
            :items="items"
            v-bind:search="formatDate(search)"
            v-bind:options.sync="pagination"
            :server-items-length="totalItems"
            :loading="loading"
            class="elevation-1"
            :footer-props="{ 'items-per-page-options': itemsPerPage }"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td v-for="column in selectedColumns" :key="column">
                  {{ row.item[column] }}
                </td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    query
                    @query="doBranchFeeQuery(row.item.effDate)"
                    remove
                    @remove="doPromptRemove(row.item.id)"
                    review
                    @review="doBranchFeeReview(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-flex>
      </v-card>
      <v-dialog v-model="FeeDialog" max-width="1000px" persistent>
        <branch-fee-review
          :branchFeeID="branchFeeID"
          :branchFeeObj="branchFeeObj"
          :newFee="newFee"
          @close="doClose"
          :boolRefresh="FeeDialog"
        ></branch-fee-review>
      </v-dialog>
      <v-dialog v-model="FeeDialogQuery" width="1000px" persistent>
        <branch-fee-query :FeeForm="FeeForm" :createdName="brnFeeCreatedName" @close="doClose"></branch-fee-query>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove"> Are you sure you want to delete this record? </confirm>
      <v-flex lg8 xs12 order-lg1 order-xs2>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
        <promptLeave title="Branch" v-model="promptLeave" :newDri="newDri" @exit="doExit"></promptLeave>
      </v-flex>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import BranchFeeReview from './BranchFeeReview'
import BranchFeeQuery from './BranchFeeQuery'
import PromptLeave from './leaveQuote/PromptLeave'
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'
import { formatDisplayDate } from '@/utils/date'
import { leaveQuote } from './leaveQuote'
import { BRANCHPARAM_LEAVEQUOTE, BRANCHPARAM_NEWBRANCH } from '@/store/types'

export default {
  data() {
    return {
      showThis: false,
      breadcrumb: [],
      title: 'Branch DRI Review',
      labels: {
        branch: 'Branch',
        dri: 'Direct / RI Inwards',
        genPolNo: 'Generate Policy No.',
        genRenNo: 'Generate Renewal No.',
        genClmNo: 'Generate Claim No.',
        perPolStp: 'Permit Policy Stamp',
        perPolFee: 'Permit Policy Fee',
        perPolTax: 'Permit Policy Tax',
        perRiskStp: 'Permit Risk Stamp',
        riskStpCls: 'Permit Risk Stamp by Business Class',
        riskStpInstall: 'Apply Risk Stamp to First Instalment',
        perRiskFee: 'Permit Risk Fee',
        riskFeeCls: 'Permit Risk Fee by Business Class',
        riskFeeInstall: 'Apply Risk Fee to First Instalment',
        perRiskTax: 'Permit Risk Tax',
        riskTaxCls: 'Permit Risk Tax by Business Class',
        riskTaxInstall: 'Apply Risk Tax to First Instalment',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      DriForm: {
        branch: null,
        dri: 'D',
        genPolNo: false,
        genRenNo: false,
        genClmNo: false,
        perPolStp: false,
        perPolFee: false,
        perPolTax: false,
        perRiskStp: false,
        riskStpCls: false,
        riskStpInstall: false,
        perRiskFee: false,
        riskFeeCls: false,
        riskFeeInstall: false,
        perRiskTax: false,
        riskTaxCls: false,
        riskTaxInstall: false,
        createdBy: null,
        createdDate: formatDisplayDate(new Date()),
        modifiedBy: null,
        modifiedDate: null
      },
      FeeForm: {
        branch: null,
        dri: null,
        effDate: null,
        riLevyPct: null,
        busStpPct: null,
        busTaxPct: null,
        polStpGN: null,
        polStpPct: null,
        minPolStp: null,
        maxPolStp: null,
        polStpRnd: null,
        polFee: null,
        polTaxGN: null,
        polTaxPct: null,
        minPolTax: null,
        maxPolTax: null,
        riskStpGN: null,
        riskStpPct: null,
        riskFeeGN: null,
        riskFeePct: null,
        riskTaxGN: null,
        riskTaxPct: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      driList: [
        { label: 'D - Direct', value: 'D' },
        { label: 'R - RI Inwards', value: 'R' }
      ],
      columns: [
        { text: 'Effective Date', value: 'effDate' },
        { text: 'RI Levy %', value: 'riLevyPct' },
        // { text: 'Business Stamp %', value: 'busStpPct' },
        // { text: 'Business Tax %', value: 'busTaxPct' },
        { text: 'Policy Stamp on', value: 'polStpGN' },
        { text: 'Policy Stamp %', value: 'polStpPct' },
        { text: 'Minimum Policy Stamp', value: 'minPolStp' },
        { text: 'Maximum Policy Stamp', value: 'maxPolStp' },
        { text: 'Policy Stamp Rounding value', value: 'polStpRnd' },
        { text: 'Policy Fee', value: 'polFee' },
        { text: 'Policy Tax on', value: 'polTaxGN' },
        { text: 'Policy Tax %', value: 'polTaxPct' },
        { text: 'Minimum Policy Tax', value: 'minPolTax' },
        { text: 'Maximum Policy Tax', value: 'maxPolTax' },
        { text: 'Risk Stamp on', value: 'riskStpGN' },
        { text: 'Risk Stamp %', value: 'riskStpPct' },
        { text: 'Risk Fee on', value: 'riskFeeGN' },
        { text: 'Risk Fee %', value: 'riskFeePct' },
        { text: 'Risk Tax on', value: 'riskTaxGN' },
        { text: 'Risk Tax %', value: 'riskTaxPct' }
      ],
      // selectedColumns: ['effDate', 'riLevyPct', 'busStpPct', 'busTaxPct'],
      selectedColumns: ['effDate', 'riLevyPct'],
      totalItems: 0,
      branchFeeObj: {},
      branchFeeID: {
        branch: null,
        dri: null
      },
      selectedId: {
        branch: null,
        dri: null,
        effDate: null
      },
      MainForm: this.$store.state.branchParam.mainform,
      newDri: false,
      DriText: '',
      createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      modifiedName: '',
      brnFeeCreatedName: '',
      FeeDialog: false,
      FeeDialogQuery: false,
      loading: false,
      promptRemove: false,
      listMessage: false,
      submitting: false,
      newFee: true,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doFetchBranchDRI(branch, dri) {
      const apiURI = this.branchMenu.getBranchDri
      const expand = { branch, dri }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.DriForm.branch = data.brnDri.branch
          this.DriForm.dri = data.brnDri.dri
          if (this.DriForm.dri === 'D') {
            this.DriText = 'D - Direct'
          } else {
            this.DriText = 'R - RI Inwards'
          }
          this.DriForm.genPolNo = data.brnDri.genPolNo
          this.DriForm.genRenNo = data.brnDri.genRenNo
          this.DriForm.genClmNo = data.brnDri.genClmNo
          this.DriForm.perPolStp = data.brnDri.perPolStp
          this.DriForm.perPolFee = data.brnDri.perPolFee
          this.DriForm.perPolTax = data.brnDri.perPolTax
          this.DriForm.perRiskStp = data.brnDri.perRiskStp
          this.DriForm.riskStpCls = data.brnDri.riskStpCls
          this.DriForm.riskStpInstall = data.brnDri.riskStpInstall
          this.DriForm.perRiskFee = data.brnDri.perRiskFee
          this.DriForm.riskFeeCls = data.brnDri.riskFeeCls
          this.DriForm.riskFeeInstall = data.brnDri.riskFeeInstall
          this.DriForm.perRiskTax = data.brnDri.perRiskTax
          this.DriForm.riskTaxCls = data.brnDri.riskTaxCls
          this.DriForm.riskTaxInstall = data.brnDri.riskTaxInstall
          this.DriForm.createdBy = data.brnDri.createdBy
          this.doFetchUsrName(this.DriForm.createdBy, 'c')
          this.DriForm.createdDate = formatDisplayDate(data.brnDri.createdDate)
          this.DriForm.modifiedBy = data.brnDri.modifiedBy
          this.doFetchUsrName(this.DriForm.modifiedBy, 'm')
          this.DriForm.modifiedDate = formatDisplayDate(data.brnDri.modifiedDate)
        }
      }
    },
    async doFetchUsrName(id, role) {
      const apiURI = this.branchMenu.getUsrName
      const expand = { id: id }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          if (role === 'c') {
            this.createdName = data.UserName
          } else if (role === 'm') {
            this.modifiedName = data.UserName
          } else {
            this.brnFeeCreatedName = data.UserName
          }
        }
      }
    },
    async doFetchBranchFeeList(branch, dri) {
      this.loading = true
      const apiURI = this.branchMenu.getBranchFeeList
      if (apiURI) {
        try {
          const expand = { branch, dri }
          const result = await this.$http.get(expandURI(apiURI, expand))
          this.totalItems = result.data.totalItems
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((BrnFee) => {
              const convertBrnFee = {
                id: {
                  branch: BrnFee.branch,
                  dri: BrnFee.dri,
                  effDate: BrnFee.effDate
                },
                effDate2: BrnFee.effDate,
                effDate: formatDisplayDate(BrnFee.effDate),
                riLevyPct: BrnFee.riLevyPct.toFixed(4),
                busStpPct: BrnFee.busStpPct.toFixed(2),
                busTaxPct: BrnFee.busTaxPct.toFixed(4),
                polStpGN: BrnFee.polStpGN,
                polStpPct: BrnFee.polStpPct.toFixed(4),
                minPolStp: BrnFee.minPolStp.toFixed(2),
                maxPolStp: BrnFee.maxPolStp.toFixed(2),
                polStpRnd: BrnFee.polStpRnd.toFixed(2),
                polFee: BrnFee.polFee.toFixed(2),
                polTaxGN: BrnFee.polTaxGN,
                polTaxPct: BrnFee.polTaxPct.toFixed(4),
                minPolTax: BrnFee.minPolTax.toFixed(2),
                maxPolTax: BrnFee.maxPolTax.toFixed(2),
                riskStpGN: BrnFee.riskStpGN,
                riskStpPct: BrnFee.riskStpPct.toFixed(4),
                riskFeeGN: BrnFee.riskFeeGN,
                riskFeePct: BrnFee.riskFeePct.toFixed(4),
                riskTaxGN: BrnFee.riskTaxGN,
                riskTaxPct: BrnFee.riskTaxPct.toFixed(4)
              }
              this.items.push(convertBrnFee)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (error) {
          this.loading = false
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.loading = false
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doUpdateBranchDRI() {
      const apiURI = this.branchMenu.updateBranchDri
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.DriForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetchBranchDRI(this.DriForm.branch, this.DriForm.dri)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doCreateBranch() {
      const apiURI = this.branchMenu.createBranch
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.MainForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCreateBranchDRI()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doCreateBranchDRI() {
      const apiURI = this.branchMenu.createBranchDri
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.DriForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          if (this.$store.state.branchParam.newBranch) {
            this.$router.push({ name: 'branchList' })
          } else {
            this.$store.commit(BRANCHPARAM_NEWBRANCH, true)
            this.$router.go(-1)
            // this.$router.push({ name: 'branchReview', params: { brn: this.DriForm.branch } })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doRemove() {
      const apiURI = this.branchMenu.deleteBranchFee
      if (apiURI) {
        this.$http
          .post(apiURI, this.selectedId)
          .then((result) => {
            const data = result.data
            this.doFetchBranchFeeList(this.selectedId.branch, this.selectedId.dri)
            this.notify(data)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    async doSaveBranchDRI() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newDri) {
            if (this.$store.state.branchParam.newBranch) {
              this.$store.commit(BRANCHPARAM_LEAVEQUOTE, false)
              this.doCreateBranch(this.MainForm)
            } else {
              this.doCreateBranchDRI(this.DriForm)
            }
          } else {
            this.doUpdateBranchDRI()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doBranchFeeQuery(effDate) {
      const apiURI = this.branchMenu.getBranchFee
      const expand = {
        branch: this.DriForm.branch,
        dri: this.DriForm.dri,
        effDate: effDate
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.FeeForm.branch = data.brnFee.branch
          this.FeeForm.dri = data.brnFee.dri
          this.FeeForm.effDate = formatDisplayDate(data.brnFee.effDate)
          this.FeeForm.riLevyPct = data.brnFee.riLevyPct
          this.FeeForm.busStpPct = data.brnFee.busStpPct
          this.FeeForm.busTaxPct = data.brnFee.busTaxPct
          this.FeeForm.polStpGN = data.brnFee.polStpGN
          this.FeeForm.polStpPct = data.brnFee.polStpPct
          this.FeeForm.minPolStp = data.brnFee.minPolStp
          this.FeeForm.maxPolStp = data.brnFee.maxPolStp
          this.FeeForm.polStpRnd = data.brnFee.polStpRnd
          this.FeeForm.polFee = data.brnFee.polFee
          this.FeeForm.polTaxGN = data.brnFee.polTaxGN
          this.FeeForm.polTaxPct = data.brnFee.polTaxPct
          this.FeeForm.minPolTax = data.brnFee.minPolTax
          this.FeeForm.maxPolTax = data.brnFee.maxPolTax
          this.FeeForm.riskStpGN = data.brnFee.riskStpGN
          this.FeeForm.riskStpPct = data.brnFee.riskStpPct
          this.FeeForm.riskFeeGN = data.brnFee.riskFeeGN
          this.FeeForm.riskFeePct = data.brnFee.riskFeePct
          this.FeeForm.riskTaxGN = data.brnFee.riskTaxGN
          this.FeeForm.riskTaxPct = data.brnFee.riskTaxPct
          this.FeeForm.createdBy = data.brnFee.createdBy
          this.FeeForm.createdDate = formatDisplayDate(data.brnFee.createdDate)
          this.doFetchUsrName(this.FeeForm.createdBy, 'f')
        }
      }
      this.FeeDialogQuery = true
    },
    async doBranchFeeReview(item) {
      this.branchFeeID.branch = this.DriForm.branch
      this.branchFeeID.dri = this.DriForm.dri
      this.branchFeeObj = item
      this.newFee = false
      this.FeeDialog = true
    },
    doNewBranchFee() {
      this.branchFeeID.branch = this.DriForm.branch
      this.branchFeeID.dri = this.DriForm.dri
      this.newFee = true
      this.FeeDialog = true
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedId.branch = data.branch
      this.selectedId.dri = data.dri
      this.selectedId.effDate = data.effDate
      this.promptRemove = true
    },
    doClose() {
      this.$validator.reset()
      this.FeeDialog = false
      this.FeeDialogQuery = false
      this.doFetchBranchFeeList(this.DriForm.branch, this.DriForm.dri)
    },
    formatDate(searchdate) {
      return formatDisplayDate(searchdate)
    },
    checkTranMode() {
      return this.tranMode === 'Query'
    },
    doCancel() {
      // this.$router.go(-1)
      this.$router.push({ name: 'branchReview' })
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('branchReview')
    this.breadcrumb.push({
      name: 'branchDriReview',
      text: this.title
    })
    // if (this.dri === 'new') {
    if (this.tranMode === 'New') {
      this.newDri = true
      this.DriForm.branch = this.branch
    } else {
      this.doFetchBranchDRI(this.branch, this.dri)
      this.doFetchBranchFeeList(this.branch, this.dri)
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName', 'checkAccess']),
    branch() {
      return this.$route.params.brn
    },
    dri() {
      return this.$route.params.brnDri
    },
    branchMenu() {
      return this.$store.state.branchParam.menu
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find((a) => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    tranMode() {
      return this.$route.params.tranMode
    }
  },
  components: {
    BranchFeeReview,
    BranchFeeQuery,
    PromptLeave
  },
  mixins: [TableConst.default, MessageMixin, FieldMixin, leaveQuote]
}
</script>

<style lang="scss">
@import '../../../assets/scss/base.scss';
</style>
